module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropzone-form')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8e212b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/New.vue
// module id = 169
// module chunks = 1